import httpClient from './httpClient'

const categoryService = {
    getList() {
        return httpClient.get(`/api/business-support/categories`).then(
            response => {
                if (response.success) {
                    let categories = response.categories
                    categories.forEach(category => {
                        category.expand = false
                        if (category.subCategories && category.subCategories.length) {
                            category.subCategories.forEach(subCategory => {
                                subCategory.expand = false
                                if (subCategory.subCategories && subCategory.subCategories.length) {
                                    subCategory.subCategories.forEach(sub => {
                                        sub.expand = false
                                    })
                                }
                            })
                        }
                    })
                    return categories
                } else {
                    return undefined
                }
            }
        )
    },
    getCategoryById(id) {
        return httpClient.get(`/api/business-support/categories/${id}`).then(
            response => response.success ? response.category : undefined
        )
    }
}

export default categoryService